<template>
  <div>
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <div class="title has-text-grey">Iniciar Sesión</div>
            <div class="box">
              <figure class="avatar">
                <img src="@/assets/img/logo-dos.png">
              </figure>

              <form @submit.prevent>
                <b-field
                  :type="{'is-danger': errors.has('usuario')}"
                  :message="errors.first('usuario')"
                >
                  <b-input
                    placeholder="Usuario"
                    autofocus
                    type="text"
                    v-model="usuario"
                    name="usuario"
                    v-validate="'required'"
                    v-on:keyup.enter="login()"
                    tabindex="1"
                    icon-pack="mdi"
                    icon="account"
                  />
                </b-field>

                <b-field
                  :type="{'is-danger': errors.has('contraseña')}"
                  :message="errors.first('contraseña')"
                >
                  <b-input
                    type="password"
                    v-model="contrasena"
                    name="contraseña"
                    v-validate="'required'"
                    tabindex="2"
                    v-on:keyup.enter="login()"
                    placeholder="Contraseña"
                    icon-pack="mdi"
                    icon="textbox-password"
                    password-reveal
                  />
                </b-field>

                <button
                  class="button is-medium is-block is-secundary is-fullwidth"
                  v-bind:class="{'is-loading': isLoading}"
                  @click="login()"
                  v-on:keyup.enter="login()"
                  tabindex="3"
                ><b-icon icon="login"></b-icon><span>Iniciar Sesión</span></button>
              </form>
            </div>
            <p class="has-text-grey">
              <router-link
                :to="{name: 'register'}"
              >Registrarse</router-link> &nbsp;·&nbsp;
              <router-link
                :to="{name: 'forgot-password'}"
              >Olvide mi contraseña</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      usuario: '',
      contrasena: '',
      isLoading: false
    }
  },
  computed: {
    jwtDecoded () {
      return this.$VueJwtDecode.decode(localStorage.getItem('jwt'))
    }
  },
  methods: {
    ...mapMutations(['hideNavAndFooter', 'showNavAndFooter', 'loginUser']),
    login () {
      var componenteVue = this

      // Funcion a ejecutarse posterior al llamado a la api para mostrar errores o proceder al inicio
      function loginCallback (error, data) {
        componenteVue.isLoading = false
        // Si hubo error se queda en la pantalla con un error
        if (error) {
          let title = ''
          let message = ''
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            title = 'Error - ' + error.response.data.status
            message = error.response.data.message
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            title = 'Error al contactar el servidor'
            message = 'No hay respuestas del servidor, posiblemente el sistema este caído temporalmente'
          } else {
            // Something happened in setting up the request that triggered an Error
            title = 'Error inesperado'
            message = `Error inesperado con mensaje: ${error.message}`
          }
          componenteVue.$buefy.dialog.alert({
            title,
            message,
            type: 'is-danger',
            hasIcon: true,
            icon: 'close-circle-outline',
            iconPack: 'mdi'
          })
        } else { // Sino  redirigue al inicio
          componenteVue.$buefy.toast.open({
            duration: 2000,
            message: 'Sesion iniciada correctamente, redirigiendo',
            position: 'is-top',
            type: 'is-success'
          })
          componenteVue.loginUser() // Llama a mutation para loguear usuario
          setTimeout(() => {
            // Si posee un redirect en el query params, lleva al usuario a dicha ruta
            if (componenteVue.$route.query.redirect) {
              componenteVue.$router.push({ path: componenteVue.$route.query.redirect })
            } else { // Si no posia query params para redirect, analiza tipo de usuario
              if (componenteVue.jwtDecoded.roles.includes(componenteVue.$constantes.roles.ADMIN)) {
                componenteVue.$router.push({ name: 'admin-pedidos' })
              } else {
                componenteVue.$router.push({ name: 'subir-fotos' })
              }
            }
          }, 800)
        }
      };

      // Hace el llamado a la api para el login y pasa como callback la funcion loginCallback
      function loginPostValidation () {
        componenteVue.$apiService.login(componenteVue.usuario, componenteVue.contrasena, loginCallback)
      };

      // Valida el form y si es valido llama a loginPostValidation, sino muestra error y queda en pantalla
      this.$validator.validateAll().then(result => {
        if (result) {
          componenteVue.isLoading = true
          loginPostValidation()
          return
        }
        componenteVue.$buefy.toast.open({
          message: 'Revise los datos',
          type: 'is-danger',
          position: 'is-top'
        })
      })
    }
  },
  mounted () {
    this.hideNavAndFooter()
  },
  beforeDestroy () {
    this.showNavAndFooter()
  }
}
</script>
